.lockBanner > span {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  top: 4px;
  height: 18px;
  padding: 2px;
  z-index: var(--cxy-z-index-internal-base);
  border-top: 1px solid var(--ogm-more-articles-border-color);
  border-left: 1px solid var(--ogm-more-articles-border-color);
  border-right: 1px solid var(--ogm-more-articles-border-color);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  color: var(--ogm-timberwolves);
  background-color: var(--cxy-color-green-400);
  text-transform: uppercase;
  font-family: var(--oc-font-family);
  font-size: 12px;
  font-weight: 600;
}
